import React from 'react';
import '../Style/appdevbenefits.css';

const icons = {
  hybrid: (
    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.6">
      <path d="M12 3 3 8l9 5 9-5-9-5Z" strokeLinecap="round" strokeLinejoin="round" />
      <path d="M3 12l9 5 9-5M3 16l9 5 9-5" strokeLinecap="round" strokeLinejoin="round" />
    </svg>
  ),
  native: (
    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.6">
      <rect x="7" y="2" width="10" height="20" rx="2.2" strokeLinecap="round" strokeLinejoin="round" />
      <path d="M11 18h2" strokeLinecap="round" />
    </svg>
  ),
  crossplatform: (
    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.6">
      <rect x="2" y="4" width="13" height="9" rx="1.5" strokeLinecap="round" strokeLinejoin="round" />
      <path d="M6 17h5" strokeLinecap="round" />
      <rect x="15.5" y="9" width="7" height="12" rx="1.5" strokeLinecap="round" strokeLinejoin="round" />
      <path d="M18.3 18.5h1.4" strokeLinecap="round" />
    </svg>
  ),
  android: (
    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.6">
      <path d="M6 10v6M18 10v6M8 9h8v9a1 1 0 0 1-1 1H9a1 1 0 0 1-1-1V9Z" strokeLinecap="round" strokeLinejoin="round" />
      <path d="M8 9a4 4 0 0 1 8 0M9.5 5 8.5 3.3M14.5 5l1-1.7" strokeLinecap="round" strokeLinejoin="round" />
      <path d="M10 20v1.3M14 20v1.3" strokeLinecap="round" />
    </svg>
  ),
  ios: (
    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.6">
      <path d="M16.7 12.6c0-2 1.6-3 1.7-3.1-1-1.4-2.4-1.6-3-1.6-1.3-.1-2.4.7-3.1.7-.6 0-1.6-.7-2.7-.7-1.4 0-2.7.8-3.4 2-1.4 2.5-.4 6.3 1 8.3.7 1 1.5 2.1 2.6 2 1-.1 1.4-.7 2.7-.7s1.6.7 2.7.6c1.1 0 1.8-1 2.5-2 .8-1.1 1.1-2.2 1.1-2.3-.1 0-2.1-.8-2.1-3.2Z" strokeLinejoin="round" />
      <path d="M13.5 5.5c.5-.6.9-1.5.8-2.4-.8 0-1.8.5-2.4 1.2-.5.6-.9 1.5-.8 2.3.9.1 1.8-.4 2.4-1.1Z" strokeLinejoin="round" />
    </svg>
  ),
  enterprise: (
    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.6">
      <path d="M4 21V7l7-4 7 4v14" strokeLinecap="round" strokeLinejoin="round" />
      <path d="M9 21v-6h4v6M9 10h.01M13 10h.01M9 13h.01M13 13h.01" strokeLinecap="round" strokeLinejoin="round" />
    </svg>
  ),
};

const Appdevbenefits = [
  {
    id: 1,
    icon: 'hybrid',
    title: 'Hybrid App Development',
    description: 'Build cost-effective hybrid mobile applications that run seamlessly across Android and iOS platforms. Our hybrid apps reduce development time while delivering excellent performance and a consistent user experience.',
  },
  {
    id: 2,
    icon: 'native',
    title: 'Native App Development',
    description: 'Develop high-performance native mobile applications optimized specifically for Android and iOS. Native apps provide faster performance, enhanced security, and full access to device capabilities.',
  },
  {
    id: 3,
    icon: 'crossplatform',
    title: 'Cross-Platform App Development',
    description: 'Create scalable cross-platform mobile applications using Flutter and React Native to launch on multiple platforms with a single codebase while reducing overall development costs.',
  },
  {
    id: 4,
    icon: 'android',
    title: 'Android App Development',
    description: 'Our Android app development services focus on building secure, scalable, and feature-rich applications that perform flawlessly across smartphones, tablets, and Android-powered devices.',
  },
  {
    id: 5,
    icon: 'ios',
    title: 'iOS App Development',
    description: 'Design and develop premium iPhone and iPad applications with intuitive interfaces, smooth performance, and seamless integration into the Apple ecosystem.',
  },
  {
    id: 6,
    icon: 'enterprise',
    title: 'Enterprise App Development',
    description: 'Build secure enterprise mobile applications that streamline business operations, improve workforce productivity, and integrate with existing enterprise software and cloud platforms.',
  },
];

const AppBenefits = () => {
  return (
    <section className="appdevbenefits-section">
      <div className="appdevbenefits-inner">
        <h2 className="appdevbenefits-heading">
          Custom Mobile App Development Services
        </h2>

        {/* FIRST ROW */}
        <div className="appdevbenefits-row">
          {Appdevbenefits.slice(0, 3).map((item) => (
            <div className="appdevbenefits-card" key={item.id}>
              <div className="appdevbenefits-card__icon-wrap">{icons[item.icon]}</div>
              <h3 className="appdevbenefits-card__title">{item.title}</h3>
              <p className="appdevbenefits-card__desc">{item.description}</p>
            </div>
          ))}
        </div>

        {/* SECOND ROW */}
        <div className="appdevbenefits-row">
          {Appdevbenefits.slice(3, 6).map((item) => (
            <div className="appdevbenefits-card" key={item.id}>
              <div className="appdevbenefits-card__icon-wrap">{icons[item.icon]}</div>
              <h3 className="appdevbenefits-card__title">{item.title}</h3>
              <p className="appdevbenefits-card__desc">{item.description}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default AppBenefits;